import { Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { MenuItemAggregate } from '../../aggregats/menu/menu-item.aggregate';
import { MenuItemsAggregate } from '../../aggregats/menu/menu-items.aggregate';
import { MenuLeftByRoleAggregate } from '../../aggregats/menu/menu-left-by-role.aggregate';
import { Role } from '../role.constantes';
import { accueilMenuItem } from './menu-items/left/accueil/menu-item.constantes';
import { communicationMenuItem } from './menu-items/left/communication/menu-item.constantes';
import { donneesMenuItem } from './menu-items/left/donnees/menu-item.constantes';
import { financierMenuItem } from './menu-items/left/financier/menu-item.constantes';
import { buildFormationMenu } from './menu-items/left/formation/menu-item.constantes';
import { parametragesMenuItem } from './menu-items/left/parametrages/menu-item.constantes';
import { relationClientsMenuItem } from './menu-items/left/relation-clients/menu-item.constantes';
import { statistiquesMenuItem } from './menu-items/left/statistique/menu-item.constantes';

const menuPersonnelAdministratifStatic: Array<MenuItemAggregate> = [
  accueilMenuItem,
  relationClientsMenuItem,
  communicationMenuItem,
  financierMenuItem,
  statistiquesMenuItem,
  donneesMenuItem,
  parametragesMenuItem,
];

const menuAdministrateurStatic: Array<MenuItemAggregate> = [
  accueilMenuItem,
  relationClientsMenuItem,
  communicationMenuItem,
  financierMenuItem,
  statistiquesMenuItem,
  donneesMenuItem,
  parametragesMenuItem,
];

const buildMenuPersonnelAdministratif = (injector: Injector): Observable<MenuItemAggregate[]> => {
  return buildFormationMenu(injector).pipe(
    map(formationMenuItems => [
      accueilMenuItem,
      formationMenuItems,
      relationClientsMenuItem,
      communicationMenuItem,
      financierMenuItem,
      statistiquesMenuItem,
      donneesMenuItem,
      parametragesMenuItem,
    ]),
  );
};

const buildMenuAdministrateur = (injector: Injector): Observable<MenuItemAggregate[]> => {
  return buildFormationMenu(injector).pipe(
    map(formationMenuItems => [
      accueilMenuItem,
      formationMenuItems,
      relationClientsMenuItem,
      communicationMenuItem,
      financierMenuItem,
      statistiquesMenuItem,
      donneesMenuItem,
      parametragesMenuItem,
    ]),
  );
};

export const menusRoles: Array<MenuLeftByRoleAggregate> = [
  new MenuLeftByRoleAggregate(Role.PersonnelAdministratif, new MenuItemsAggregate(buildMenuPersonnelAdministratif)),
  new MenuLeftByRoleAggregate(Role.Administrateur, new MenuItemsAggregate(buildMenuAdministrateur)),
];

